// Initialize Sentry as early as possible
import './sentry.client';

// Main application entry point
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { AppRoutes } from '@/routes/routes';
import QueryProvider from '@/providers/QueryProvider';
import { Analytics } from '@/components/analytics/Analytics';
import { HelmetProvider } from 'react-helmet-async';
import GrowthBookWrapper from '@/providers/GrowthBookWrapper';
import * as Sentry from '@sentry/react';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary>
      <QueryProvider>
        <BrowserRouter>
          <Analytics />
          <HelmetProvider>
            <GrowthBookWrapper>
              <AppRoutes />
            </GrowthBookWrapper>
          </HelmetProvider>
        </BrowserRouter>
      </QueryProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
